var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip",style:(_vm.customStyle),on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.hoverNumber)?_c('div',{class:_vm.hoverClass},[_vm._v(" "+_vm._s(_vm.totalNumber)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }